// Libs
import React from 'react';
// Components
import OrdersOverview from '../OrdersOverview/OrdersOverview';

const OrdersNotpay = props => (
	<OrdersOverview {...props} orderFlowType='orders_notpay' />
);
export default OrdersNotpay;
